import { useEffect, useRef, useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'

import { cn } from '../../../libs/tailwindMerge'

interface GroupsDashboardButtonsProps {
  storeGroups: {
    id: string
    name: string
    logo_url: string
  }[]
  onSelectGroup: (id: string) => void
  selectedGroup: string | undefined
}

export function GroupsDashboardButtons({ storeGroups, onSelectGroup, selectedGroup }: GroupsDashboardButtonsProps) {
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(false)
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      const div = scrollRef.current
      if (div) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current
        setShowLeftArrow(scrollLeft > 0)
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth)
      }
    }

    handleScroll()

    const div = scrollRef.current
    if (div) {
      div.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (div) {
        div.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  return (
    <section className="relative">
      {showLeftArrow && (
        <div className="absolute left-0 h-full w-6 flex items-center justify-center bg-gradient-to-r from-slate-100 to-transparent">
          <FaChevronLeft className="w-6 h-6 text-gray-400" />
        </div>
      )}
      {showRightArrow && (
        <div className="absolute right-0 h-full w-6 flex items-center justify-center bg-gradient-to-l from-slate-100 to-transparent">
          <FaChevronRight className=" w-6 h-6 text-gray-400" />
        </div>
      )}
      <div ref={scrollRef} className="flex overflow-x-auto w-full">
        <div className="flex h-24 gap-4 px-4">
          {storeGroups.map(item => (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelectGroup(item.id)}
              className={cn(
                'flex items-center w-24 justify-center p-2 mb-2 rounded-md border bg-white transition-all overflow-hidden',
                selectedGroup && selectedGroup !== item.id
                  ? 'saturate-0'
                  : 'shadow-md',
              )}
              title={item.name}
            >
              <img className="min-h-[75.8px] object-contain" src={item.logo_url} alt={item.name} />
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}
